//
// locales/vanilla/fr.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/fr.json';
import localeData from 'react-intl/locale-data/fr.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
